import styled from 'styled-components/macro';
import isMobile from '../../utils/detectMobileAccurate';
import { copyFor } from '../../copy/copy';
import { detect } from '../../utils/detect-browser';

const MobileStyles = primaryColor => `
    top: 70%;
    margin-bottom: 0;

    #label-pipe-file-input-vidContainer{
        width: 90%;
        margin: 0 1rem;
        font-family: Lato;
        position: absolute;
        left: 0;
        font-size: 28px;
        line-height: 32px;
        font-weight: 600;
        background: white;
        color: black;
        border-radius: 4px;
        border: 1px #f1f1ee solid;
        padding: 1rem;
        opacity: 1 !important;
        transition: none !important;
    }

    #label-pipe-file-input-vidContainer:active{
        background: ${primaryColor};
        color: white;
    }
`
const isFirefox = detect().name === 'firefox';

export default styled.div`
    position: absolute;
    z-index: 2;
    left: ${props => (props.vidStyles.visible ? '0px' : '650px')};
    transition: 0.45s all linear;
    width: 100%;
    height: ${isFirefox ? '100%' : '-webkit-fill-available'} !important;
    
    #pipeClickPowered-vidContainer {
        display: none;
    }

    #pipeVideoInput-vidContainer,
    #pipeMenu-vidContainer {
        border-radius: 0 !important;
    }

    #pipeMenu-vidContainer {
        padding: 1px 0;
        background: #fff !important;
    }
    
    #pipeVideoInput-vidContainer, #pipeMenu-vidContainer, #pipeVrec-vidContainer{
        width: 100% !important;
    }

    #pipeVrec-vidContainer{
        height: 100% !important;    
    }

    #pipeVrec-vidContainer{
        display: flex;
        flex-direction: column;
    }

    #pipeVideoInput-vidContainer{
        flex-grow: 1;
    }

    &.pipeMobileRecorder{
        max-height: 6rem !important;
        transition: none !important;
    }
    
    #pipeCounter-vidContainer{
        right: 2.5rem !important;
        left: unset !important;
    }

    #pipeSaveVideo-vidContainer::after {
        content: "${copyFor('controls','save','recordvideo')}";
    }
    #pipeRec-vidContainer::after {
        content: "${props => copyFor('controls', props.isRerecord ? 'rerecord' : 'record','recordvideo')}";
    }
    #pipeRec-vidContainer{
        width: 98px !important;
    }
    #pipeRec-vidContainer[title="${copyFor('controls','stop','recordvideo')}"]::after {
        content: "${copyFor('controls','stop','recordvideo')}";
    }
    #pipePlay-vidContainer::after {
        content: "${copyFor('controls','play','recordvideo')}";
    }
    #pipePlay-vidContainer[title="${copyFor('controls','pause','recordvideo')}"]::after {
        content: "${copyFor('controls','pause','recordvideo')}";
    }
    #pipePlay-vidContainer{
        width: 69px !important;
    }

    .pipeBtn, .pipeBtnOff{
        font-size: 20px;
        background: white;
        padding: 0px 7px;
        border-radius: 4px;
        border: 1px #f1f1ee solid;
        margin-left: 2px;
        color: black;
        outline: none;
        text-align: center;
        text-transform: capitalize;
    }
    .pipeBtn:hover{
        background: ${({ theme }) => theme.colors.primary};
        border: solid 1px ${({ theme }) => theme.colors.primary};
        color: #fff;
    }

    .pipeBtn svg, .pipeBtnOff svg {
        display: none;
    }

    ${({ theme }) => isMobile() && MobileStyles(theme.colors.primary)}
`;
